import { Alert, Button } from '30pay/components';
import { CardNumberSelectionModal } from '30pay/wallet/deposit/cardNumberSelectionModal/cardNumberSelectionModal.index';
import { Spin } from 'antd';
import { BankAccount } from 'interfaces';
import { useEffect, useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { detectBank, formatCardNumber } from 'scripts';
import { getCardNumbers } from 'services';
import { Card } from 'utilities/components';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi2';
import { __BuySelectCardConvertBoxProps } from './buySelectCard.interface';
import { ConvertBoxDataType } from '../convertBox.index';

const ConvertBoxBuySelectCard: React.FC<__BuySelectCardConvertBoxProps> = (props: __BuySelectCardConvertBoxProps) => {
    const [cardNumbersLoading, setCardNumbersLoading] = useState(true);
    const [cardNumbers, setCardNumbers] = useState<Omit<BankAccount, 'iBan'>[]>();
    const [selectedCardNumber, setSelectedCardNumber] = useState<Omit<BankAccount, 'iBan'>>();
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const onCardNumberSelection = (cardNumber: Omit<BankAccount, 'iBan'>) => {
        setSelectedCardNumber(cardNumber);
        setModalOpen(false);
    };
    useEffect(() => {
        getCardNumbers(setCardNumbersLoading, setCardNumbers, setSelectedCardNumber);
    }, []);

    function submitHandler() {
        const output: ConvertBoxDataType = {
            bankAccountId: selectedCardNumber?.id
        }
        props.onSubmit(output);
    }

    function backHandler() {
        props.onBack();
    }

    return (
        <div className="flex max-lg:flex-col gap-6 h-full">
            {cardNumbers &&
                <CardNumberSelectionModal open={modalOpen} setOpen={setModalOpen} cardNumbers={cardNumbers}
                    onSelect={onCardNumberSelection} />
            }
            <Card loading={cardNumbersLoading} className="flex-1" title="انتخاب کارت" titleDivider>
                <label className={"max-lg:text-sm"}>شماره کارت:</label>
                <div
                    onClick={() => setModalOpen(true)}
                    className={
                        'flex justify-between items-center border border-primary-40 rounded-[28px] text-base px-6 h-14 max-lg:h-12 max-lg:text-sm mt-2 clickable'
                    }
                >
                    {!cardNumbersLoading && (selectedCardNumber ? (
                        <>
                            <div className={'flex items-center gap-4'}>
                                <img src={detectBank(selectedCardNumber?.cardNumber)?.bank_logo}
                                    className={'w-6 h-6'} />
                                {selectedCardNumber?.bank?.name}
                            </div>
                            {formatCardNumber(selectedCardNumber?.cardNumber)}
                            <BsChevronDown />
                        </>
                    ) : <p className="text-sm mx-auto font-medium text-darkPurple-40">برای انتخاب کارت کلیک کنید</p>)}
                </div>
                <div className="flex items-center w-full gap-4 mt-6">
                    <Button onClick={submitHandler} className="w-full h-16" type="primary">
                        <HiArrowRight />
                        ادامه
                    </Button>
                    <Button onClick={backHandler} className="w-full h-16 bg-background" type="text">
                        بازگشت
                        <HiArrowLeft />
                    </Button>
                </div>
            </Card>
            <div className="flex flex-col gap-6 flex-1">
                <Alert message="حتماً به آدرس صفحه‌ی درگاه بانکی دقت نموده و تنها پس از اطمینان از حضور در سایت‌های سامانه‌ی شاپرک مشخصات کارت بانکی خود را وارد نمایید." variant="info" />
            </div>
        </div>
    );
};
export default ConvertBoxBuySelectCard;
